import React from 'react';

import AddPaymentMethodModal from '../AddPaymentMethodModal/AddPaymentMethodModal';
import BuyTrialCreditModal from '../BuyTrialCreditModal';
import CancelReservationModal from '../CancelReservationModal';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import ConfirmLessonModal from '../ConfirmLessonModal';
import ServicePlanModal from '../ServicePlanModal/ServicePlanModal';
import PauseMembershipModal from '../PauseMembershipModal';
import UpgradeMembershipModal from '../UpgradeMembershipModal';
import BeforeDeleteMembershipModal from '../DeleteMembershipModals/Before';
import DeleteMembershipStep1Modal from '../DeleteMembershipModals/Step1';
import DeleteMembershipStep2Modal from '../DeleteMembershipModals/Step2';
import DeleteMembershipStep3Modal from '../DeleteMembershipModals/Step3';
import RescheduleReservationModal from '../RescheduleReservationModal';
import LoginModal from '../LoginModal';
import SignUpModal from '../SignUpModal';
import TrialUpgradeModal from '../TrialUpgradeModal';
import TeacherLessonConfirmationModal from '../TeacherLessonConfirmationModal';
import WarnModal from '../WarnModal/WarnModal';

const ModalDeclarations = () => {
  return (
    <div className="ModalDeclarations">
      <AddPaymentMethodModal />
      <CancelReservationModal />
      <ConfirmLessonModal />
      <ServicePlanModal />
      <ConfirmationModal />
      <PauseMembershipModal />
      <UpgradeMembershipModal />
      <BeforeDeleteMembershipModal />
      <DeleteMembershipStep1Modal />
      <DeleteMembershipStep2Modal />
      <DeleteMembershipStep3Modal />
      <RescheduleReservationModal />
      <LoginModal />
      <SignUpModal />
      <BuyTrialCreditModal />
      <TrialUpgradeModal />
      <TeacherLessonConfirmationModal />
      <WarnModal />
    </div>
  );
};

export default ModalDeclarations;



// WEBPACK FOOTER //
// ./src/components/modals/ModalDeclarations/ModalDeclarations.js